<h2 mat-dialog-title>Créer une nouvelle session</h2>
<mat-dialog-content>
    <mat-form-field class="w-full">
        <mat-label>Nom de la session</mat-label>
        <input 
            matInput 
            type="text" 
            [(ngModel)]="sessionName" 
            placeholder="BODEMER - AO 2025/637289" 
            (keydown.enter)="createSession()">
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]>Annuler</button>
    <button matButton [disabled]="!canCreateSession()" (click)="createSession()">
        @if (!canCreateSession()) {
            <i class="spinner-btn custom-spinner"></i>
        } @else {
            Confirmer
        }
    </button>
</mat-dialog-actions>